import React from 'react';
import ReferralContainer from '../containers/referral_container';

const ReferralContext = React.createContext(new ReferralContainer());

export default ReferralContext;
